'use client';

export * from '@coolblue-development/freddy';
